<template>
  <div id="orders-buttons">
    <v-menu left offset-y class="orders-buttons-menu" content-class="elevation-2">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          small
          color="primary"
          class="ml-2 px-2 elevation-0 orders-buttons-menu-plus-button"
          v-on="on"
        >
          <span class="button-text px-1">
            {{ $t('views.common.addButtons.new') }}
          </span>
          <v-icon :size="isMobile ? 22 : 20" class="orders-buttons-plus-icon">
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>

      <v-list nav class="orders-buttons-list">
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          class="py-0 pl-3 pr-4"
          @click="$emit('clicked', item.value, item.subvalue)"
        >
          <v-list-item-title>
            <v-icon :size="item.size || 18" class="mr-3 orders-buttons-icon" :color="item.color">
              {{ item.icon }}
            </v-icon>
            <span>{{ item.title }}</span>
            <v-icon v-if="item.new" class="ml-2 orders-buttons-new-icon" color="primary">
              mdi-new-box
            </v-icon>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
const { ORDERS_TYPE_PALETTE, DIVIDENDS_TYPE_PALETTE } = require('@/lib/colors.js')

export default {
  props: {
    type: {
      required: true,
      type: String,
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
    items() {
      if (this.type === 'dividend') {
        return [
          {
            value: 'stockDividend',
            title: this.$t('views.common.addButtons.stockDividend'),
            icon: 'mdi-piggy-bank-outline',
            color: DIVIDENDS_TYPE_PALETTE.stockDividend,
          },
          {
            value: 'coupon',
            title: this.$t('views.common.addButtons.coupon'),
            icon: 'mdi-tag-text-outline',
            color: DIVIDENDS_TYPE_PALETTE.coupon,
          },
        ]
      } else {
        return [
          {
            value: 'buy',
            title: this.$t('views.common.addButtons.buy'),
            icon: 'mdi-plus-circle-multiple-outline',
            color: ORDERS_TYPE_PALETTE.buy,
          },
          {
            value: 'sell',
            title: this.$t('views.common.addButtons.sell'),
            icon: 'mdi-minus-circle-multiple-outline',
            color: ORDERS_TYPE_PALETTE.sell,
          },
          {
            value: 'deposit',
            title: this.$t('views.common.addButtons.deposit'),
            icon: 'mdi-bank-plus',
            color: ORDERS_TYPE_PALETTE.deposit,
            size: 16,
          },
          {
            value: 'withdrawal',
            title: this.$t('views.common.addButtons.withdrawal'),
            icon: 'mdi-bank-minus',
            color: ORDERS_TYPE_PALETTE.withdrawal,
            size: 16,
          },
          {
            value: 'switch',
            subvalue: 'fund',
            title: this.$t('views.common.addButtons.switch.fund'),
            icon: 'mdi-circle-multiple-outline',
            color: ORDERS_TYPE_PALETTE.switch,
          },
          {
            value: 'switch',
            subvalue: 'cash',
            title: this.$t('views.common.addButtons.switch.cash'),
            icon: 'mdi-circle-multiple',
            color: ORDERS_TYPE_PALETTE.switch,
          },
          {
            value: 'optionBuy',
            title: this.$t('views.common.addButtons.optionBuy'),
            icon: 'mdi-plus-box-multiple-outline',
            color: ORDERS_TYPE_PALETTE.buy,
          },
          {
            value: 'optionSell',
            title: this.$t('views.common.addButtons.optionSell'),
            icon: 'mdi-minus-box-multiple-outline',
            color: ORDERS_TYPE_PALETTE.sell,
          },
          {
            value: 'interest',
            title: this.$t('views.common.addButtons.interest'),
            icon: 'mdi-bank-check',
            color: ORDERS_TYPE_PALETTE.interest,
          },
          {
            value: 'moreOptions',
            title: this.$t('views.common.addButtons.moreOptions'),
            icon: 'mdi-plus',
            color: this.$vuetify.theme.dark ? 'white' : 'black',
            size: 16,
          },
        ]
      }
    },
  },
}
</script>

<style lang="scss">
.orders-buttons-list {
  .orders-buttons-icon {
    margin-bottom: 3px;
  }
  .v-list-item {
    min-height: 35px !important;
  }
  .orders-buttons-new-icon {
    margin-bottom: 1px;
  }
}
#orders-buttons {
  .orders-buttons-menu-plus-button {
    margin-top: 1px;
    // height: 33px;
  }
  .orders-buttons-plus-icon {
    margin-bottom: 1px;
  }
  .button-text {
    // font-weight: 500;
  }
}
</style>
